/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemAnswerTextCorrectionGridDetailViewModel } from "../types/ExamItemAnswerTextCorrectionGridDetailViewModel.ts";

export const examItemAnswerTextCorrectionGridDetailViewModelSchema = z.object({
  examPublishId: z.optional(
    z
      .number()
      .int()
      .describe("ID da publicação da prova associada à correção."),
  ),
  classroomDisciplineId: z.optional(
    z
      .number()
      .int()
      .describe("ID da disciplina da turma à qual a prova pertence."),
  ),
  teacherName: z
    .string()
    .describe("Nome do professor responsável pela disciplina.")
    .nullish(),
  disciplineName: z
    .string()
    .describe("Nome da disciplina associada à prova.")
    .nullish(),
  publishStartDate: z.optional(
    z.string().datetime().describe("Data de início da publicação da prova."),
  ),
  publishEndDate: z.optional(
    z.string().datetime().describe("Data de término da publicação da prova."),
  ),
  examName: z.string().describe("Nome da prova publicada.").nullish(),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa associada à publicação da prova. Opcional.")
    .nullish(),
  classStudentId: z
    .number()
    .int()
    .describe("ID da turma do aluno associada à publicação da prova. Opcional.")
    .nullish(),
  isOnDemand: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a prova pertence a uma disciplina ofertada no formato on demand.",
      ),
  ),
}) as unknown as ToZod<ExamItemAnswerTextCorrectionGridDetailViewModel>;
